// import { log } from "../../";
import * as React from "react";
import { observer, inject } from "mobx-react";
import ReactCardFlip from "react-card-flip";

// Models
import { CategoryType } from "models";

// Components
import PreviewCategoryItemCard from "./PreviewCategoryItemCard";
import { CategoryItemCardProps } from "./CategoryItemCard";
import TextCard from "components/common/TextCard";

// Utils
import * as Icons from "core/utils/Icons";
import { Colors } from "core/utils/Colors";
import { DynamicTypography, DynamicTypographyType } from "core/utils/DynamicTypography";
import { Fonts } from "core/utils/Fonts";
import { FLIP_CARD_INDEX } from "layers";
import Utils from "core/utils/Utils";
import { Row } from "layout";
import SoundEffectPlayer from "core/utils/SoundEffectPlayer";
import CategoryItemCardContainer from "./CategoryItemCardContainer";
import { ActivityCategoryItem } from "models/customLists/CategoryItem";

const CardBack = (props: CategoryItemCardProps) => {
    let { lessonSelection, showWrongAnswers, rootStore, ...other } = props;
    return (
        <CategoryItemCardContainer {...other} backgroundColor={Colors.lightGrey}>
            <DynamicTypography
                variant={DynamicTypographyType.H4}
                style={{ padding: 10, fontFamily: Fonts.BalsamiqSans }}
            >
                {props.title}
            </DynamicTypography>
        </CategoryItemCardContainer>
    );
};

const DoubleSidedCardBack = (props: CategoryItemCardProps) => {
    let id = Utils.guid();
    let { lessonSelection, showWrongAnswers, rootStore, ...other } = props;

    let text = props.item.answer.text;
    let audio = props.item.answer.audio;

    // if (selectedCategoryType === CategoryType.Expression || selectedCategoryType === CategoryType.ExpressionTextOnly) {
    //     text = props.item.answer;
    //     audio = props.item.answerAudioURL;
    // }
    return (
        <CategoryItemCardContainer {...other} backgroundColor={Colors.white}>
            <Row
                style={{ cursor: "pointer" }}
                center="xs"
                middle="xs"
                id={id}
                onClick={(event: any) => {
                    SoundEffectPlayer.play(audio);
                }}
            >
                <TextCard
                    imageContainerId={id}
                    text={text}
                    textType={DynamicTypographyType.H2}
                    maxHeight={props.cardHeight}
                />
            </Row>
        </CategoryItemCardContainer>
    );
};

const DoubleSidedCardFront = (props: CategoryItemCardProps) => {
    let id = Utils.guid();
    return (
        <Row
            style={{ cursor: "pointer" }}
            center="xs"
            middle="xs"
            id={id}
            onClick={(event: any) => {
                SoundEffectPlayer.play(props.item.answer.text);
            }}
        >
            <PreviewCategoryItemCard {...props} />
        </Row>
    );
};

interface CardWithFlipButtonProps {
    allowFlip: boolean;
    onResetCallback: (event: any) => void;
    children?: any;
}

const CardWithFlipButton = (props: CardWithFlipButtonProps) => {
    return (
        <>
            {props.allowFlip && (
                <div style={{ position: "absolute", top: 5, right: 10, zIndex: FLIP_CARD_INDEX }}>
                    <Icons.Replay onClick={props.onResetCallback} style={{ cursor: "pointer" }} />
                </div>
            )}
            {props.children}
        </>
    );
};

export interface FlippablePreviewCardProps extends CategoryItemCardProps {
    allowFlip: boolean;
    isFlipped: boolean;
    title: string;
    onItemFlippedCallback: (item: ActivityCategoryItem, isFlipped: boolean) => void;
}

@inject("rootStore")
@observer
export default class FlippablePreviewCard extends React.Component<FlippablePreviewCardProps> {
    render() {
        let { isFlipped, onItemFlippedCallback, ...other } = this.props;
        let { activityOptions, currentCategory } = this.props.rootStore.activityStore;
        let { useDoubleSidedCards } = activityOptions.flashcardsOptions;
        let useDoubleSided = useDoubleSidedCards && currentCategory.type !== CategoryType.VocabularyTextOnly;
        return (
            <ReactCardFlip isFlipped={this.props.isFlipped}>
                <CardWithFlipButton key="front" allowFlip={this.props.allowFlip} onResetCallback={this.onCardClicked}>
                    {useDoubleSided ? <DoubleSidedCardFront {...other} /> : <PreviewCategoryItemCard {...other} />}
                </CardWithFlipButton>
                <CardWithFlipButton key="back" allowFlip={this.props.allowFlip} onResetCallback={this.onCardClicked}>
                    {useDoubleSided ? <DoubleSidedCardBack {...other} /> : <CardBack {...other} />}
                </CardWithFlipButton>
            </ReactCardFlip>
        );
    }

    private onCardClicked = (event: any) => {
        event.preventDefault();
        this.props.onItemFlippedCallback(this.props.item, !this.props.isFlipped);
    };
}
